module.exports = __webpack_public_path__ + "static/img/background.1df1ca09.svg";